import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "./OverPanel.css";
import "./ReplyByMail.css";
import MailIcon from "../../../media/assets/MailIcon.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import {Button, ButtonGroup, Form, Input} from "reactstrap";
import appLib from "../../../libs/appLib.mjs";

const prefix = "ReplyByMail";

const ReplyByMail = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage()
		}
		this.uid = Glob.generateUid(prefix);
		this.close = this.close.bind(this);
		this.setVal = this.setVal.bind(this);
		this.save = this.save.bind(this);
	}
	componentDidMount() {
		Glob.register('EscapeKeyWasPressed', this.close, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	close() {
		Glob.trigger('ReplyByMail');
	}
	setVal(e) {
		const body = (e.target.value||'').replace(/\t+/g, ' ');
		this.setState({
			body: body,
			valid: (body.trim().length > 16)
		});
	}
	save() {
		this.setState({saving: true}, ()=>{
			appLib.api('bacheca/mail-reply',{message: this.props.message.id, body: this.state.body.trim() }).then(() => {
				this.close();
			}).catch(() => {
				this.close();
			}).finally(() => {
				this.setState({saving: false});
			})
		});
	}
	render() {
		const m = this.props.message;
		return (
			<div
				className={"OverPanel "+prefix+( this.state.saving ? " busy" : "" )}
				onClick={ this.close }
			>
				<div onClick={ e => e.stopPropagation() }>
					<Form
						key={ this.state.updated }
						onSubmit={ e => {
							e.preventDefault();
							if ( this.state.valid ) this.save();
						} }
					>
						<h2>
							<MailIcon />
							<span><TextLabel value={"Reply"} /></span>
							<span
								className={"closer"}
								onClick={this.close}
							>
								<CloseIcon />
							</span>
						</h2>
						<h4>
							«<strong>{ m.subject }</strong>»
						</h4>
						{ this.state.lang === "it" ? (
							<>
								<p>
									L’autore «<strong>{ m.meta.name }</strong>» riceverà una mail, da cui potrà direttamente
									rispondere a <em>{ this.props.user.email }</em>
								</p>
								<p>
									La mail riporterà automaticamente anche i dati del messaggio a cui stai rispondendo.
								</p>
							</>
						) : (
							<>
								<p>
									The author, «<strong>{ m.meta.name }</strong>», will receive a mail message.<br />
									{ m.meta.name } will have the option to answer directly to your mailbox <em>{ this.props.user.email }</em>
								</p>
								<p>
									The mail will automatically report the message you’re anwering to.
								</p>
							</>
						)}
						<Input
							autoFocus={ true }
							name={"body"}
							type={"textarea"}
							maxLength={960}
							value={ this.state.body||''}
							onChange={ this.setVal }
						/>
						<ButtonGroup className={"btn-icon"}>
							<Button
								color="warning"
								onClick={ this.close }
								type={"reset"}
							>
								<i>
									<CloseIcon />
								</i>
								<b>
									<TextLabel value={"Cancel"} />
								</b>
							</Button>
							<Button
								color="primary"
								type="submit"
								disabled={ ! this.state.valid }
							>
								<b>
									{ this.state.valid ? (
										this.state.lang==='it' ? "Invia la mail" : "Send the email"
									) : (
										this.state.lang==='it' ? "Scrivi qualcosa…" : "Write something…"
									) }
								</b>
								<i>
									<MailIcon />
								</i>
							</Button>
						</ButtonGroup>
					</Form>
				</div>
			</div>
		)
	}
}

export default ReplyByMail;